// module cache are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("../../local/lib/node_modules/expo-cli/node_modules/webpack-dev-server/client/index.js?protocol=ws%3A&hostname=0.0.0.0&port=51001&pathname=%2F_expo%2Fws&logging=none&overlay=false&reconnect=10&hot=true&live-reload=true");
__webpack_require__("../../local/lib/node_modules/expo-cli/node_modules/webpack/hot/dev-server.js");
var __webpack_exports__ = __webpack_require__("./node_modules/expo/AppEntry.js");
